// extracted by mini-css-extract-plugin
export default {"BasicCheckbox":"BasicCheckbox_BasicCheckbox__6t6z6","CenteredCheckbox":"BasicCheckbox_CenteredCheckbox__7rK0f","NotifyCheckbox":"BasicCheckbox_NotifyCheckbox__DX0Xt"};